/**
 * 一个单独的vue实例，用来处理兄弟组件之间的传值
 */
import Vue from 'vue';

export default new Vue();
